import React from 'react'

interface AIVoiceWaveProps {
  className?: string
  color?: string
}

export const AIVoiceWave: React.FC<AIVoiceWaveProps> = ({ 
  className = "", 
  color = "currentColor" 
}) => {
  return (
    <div className={`flex items-center gap-[3px] h-4 ${className}`}>
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className="w-[3px] rounded-full animate-ai-wave"
          style={{
            backgroundColor: color,
            height: '100%',
            animationDelay: `${i * 0.15}s`,
            animationDuration: '0.8s'
          }}
        />
      ))}
      <style>{`
        @keyframes ai-wave {
          0%, 100% { transform: scaleY(0.4); }
          50% { transform: scaleY(1.2); }
        }
        .animate-ai-wave {
          animation-name: ai-wave;
          animation-iteration-count: infinite;
          animation-timing-function: ease-in-out;
          transform-origin: center;
        }
      `}</style>
    </div>
  )
}
